import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  ListGroup,
  ListGroupItem,
  Nav,
  NavItem,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu
} from "reactstrap";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { NavLink as NavLinkStrap } from "reactstrap";

import { logout } from "reducers/UserAuth";

const HeaderUserbox = ({ logout }) => {
  const history = useHistory();

  const handleLogout = (e) => {
    e.preventDefault();
    logout().then(() => {
      history.push("/login");
    });
  };
  return (
    <>
      <UncontrolledDropdown className="position-relative ml-2">
        <DropdownToggle
          color="link"
          className="p-0 text-left d-flex btn-transition-none align-items-center">
          <div className="d-block p-0 avatar-icon-wrapper">
            <div className="avatar-icon rounded">
              <img src={"https://via.placeholder.com/150"} alt="..." />
            </div>
          </div>
          <div className="d-xl-block pl-2">
            <div className="text-white">{localStorage.getItem("name")}</div>
            <span className="text-white-50">
              {localStorage.getItem("roleName")}
            </span>
          </div>
          <span className="pl-1 pl-xl-3">
            <FontAwesomeIcon
              icon={["fas", "angle-down"]}
              className="opacity-5"
            />
          </span>
        </DropdownToggle>
        <DropdownMenu right className="dropdown-menu-lg overflow-hidden p-0">
          <ListGroup flush className="text-left bg-transparent">
            <ListGroupItem className="rounded-top">
              <Nav pills className="nav-neutral-primary flex-column">
                <NavItem>
                  <NavLinkStrap href="#/" onClick={(e) => e.preventDefault()}>
                    My Profile
                  </NavLinkStrap>
                </NavItem>
                <NavItem>
                  <NavLinkStrap href="#/" onClick={handleLogout}>
                    Logout
                  </NavLinkStrap>
                </NavItem>
              </Nav>
            </ListGroupItem>
          </ListGroup>
        </DropdownMenu>
      </UncontrolledDropdown>
    </>
  );
};

const mapDispatchToProps = {
  logout
};

export default connect(null, mapDispatchToProps)(HeaderUserbox);
